import { Action, ActionType, ContextState } from './types'

/**
 * Approval context provider reducer.
 * @param {State} state
 * @param {Action} action
 * @returns {State}
 */
export function reducer(state: ContextState, action: Action): ContextState {
  switch (action.type) {
    case ActionType.handleUpdateSortBy: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case ActionType.handleUpdateSubmittedBy: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case ActionType.handleUpdateSubmittedFrom: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case ActionType.handleUpdateSubmittedTo: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case ActionType.resetAllFilters: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case ActionType.setApprovalRequests: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case ActionType.setIsLoading: {
      return {
        ...state,
        isLoading: action.payload,
      }
    }
    case ActionType.setPage: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case ActionType.setReviewingRequest: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case ActionType.setSubmittedByOptions: {
      return {
        ...state,
        submittedByOptions: action.payload,
      }
    }
    case ActionType.setSortOptions: {
      return {
        ...state,
        sortOptions: action.payload,
      }
    }
    default:
      return state
  }
}
